module.exports = __webpack_public_path__ + "static/media/pic_normalerror.02c240a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/pic_normalerror.svg
// module id = 266
// module chunks = 0